import { axiosHelper } from 'Services/AxiosHelper';
import { MasterpassTokenModel } from 'Models';
import { masterpassTokenReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

/**
 * Masterpass token servisi — v1 ve v2 için TEK uç.
 *
 * Bir dönem v2 için ayrı yazılan `RI.OnGenerateJwtoken` KALDIRILDI. Backend
 * dallandığı için bu servis hangi sürüm aktifse ona uygun token'ı üretiyor ve
 * cevaptaki `IsVersion2Active` ile hangisi olduğunu bildiriyor.
 *
 * ⚠️ İstek gövdesi sürüme göre DEĞİŞMEZ — karar backend'de, biz yalnızca cevabı
 * okuyoruz.
 */
const command = 'RI.OnGenerateTLVToken';

const onGenerateTLVToken = async (params: masterpassTokenReqBodyData): Promise<MasterpassTokenModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

/**
 * Cevaptan Masterpass token'ını çıkarır (v1'de TLV, v2'de JWT).
 *
 * ⚠️ v2'de değer `"Bearer "` ön ekiyle gelir; ön ek TEMİZLENMEZ — SDK'nın
 * `setToken` ve `decodeJwt` fonksiyonları ikisini de kabul eder.
 */
export const extractMasterpassToken = (response?: MasterpassTokenModel): string | undefined => {
  const data = response?.data;

  if (data?.Token) {
    return data.Token;
  }

  // Beklenen alan yoksa sorunu jenerik bir hataya gömmek yerine servisin
  // GERÇEKTE ne döndürdüğünü bildiriyoruz; teşhis çok daha hızlı oluyor.
  if (data) {
    const gatewayFields = ['ResponseCode', 'ResponseSubCode', 'ResponseDescription'];
    const payloadFields = Object.keys(data).filter((key) => !gatewayFields.includes(key));

    console.error(
      '[Masterpass] Token cevapta bulunamadı (beklenen alan: Token). ' +
        `Servisin döndürdüğü alanlar: ${payloadFields.length ? payloadFields.join(', ') : '(yok)'}. ` +
        `ResponseCode: ${data.ResponseCode ?? '-'} ${data.ResponseDescription ?? ''}`
    );
  }

  return undefined;
};

/**
 * Cevaptaki sürüm anahtarını okur.
 *
 * ⚠️ Alan string (`"true"` / `"True"`) ya da boolean gelebiliyor; sürüm kararı
 * HER ZAMAN bu fonksiyondan geçmelidir. Doğrudan `if (data.IsVersion2Active)`
 * yazmak `"false"` string'ini doğru sanıp uygulamayı yanlış SDK'ya sokar.
 *
 * Alan hiç gelmezse v1 varsayılır: v1 eski ve hâlâ geçerli davranıştır, sürüm
 * bilgisi olmadan v2'ye geçmek riskli olur.
 */
export const isMasterpassVersion2 = (response?: MasterpassTokenModel): boolean => {
  const value = response?.data?.IsVersion2Active;

  if (typeof value === 'boolean') {
    return value;
  }

  return typeof value === 'string' && value.trim().toLowerCase() === 'true';
};

export default onGenerateTLVToken;
